import { DSButton } from 'designSystem/DSButton';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { BackgroundImage, Image } from 'shared/components/Image';

const Pudzian404 = '/offline/appUnavailablePudzian.png';
const Text404 = '/offline/appUnavailableText.svg';

const DYNAMIC_IMPORTS_ERRORS = ['Failed to fetch dynamically imported module', 'Importing a module script failed'];

type Props = {
	canReload?: boolean;
	error?: any;
};

const AppUnavailable: FC<Props> = ({ canReload, error }) => {
	const { t } = useTranslation();

	// when new version of an app is deployed new chunks are generated, but the app asks for old chunks
	// unless the page is refreshed and new version is loaded. Therefore we must catch the error that is thrown
	// when router asks for chunk which no longer exists and trigger page reload after which the app will be updated.
	useEffect(() => {
		const isDynamicImportError = error instanceof TypeError && DYNAMIC_IMPORTS_ERRORS.some((err) => error.message.includes(err));
		if (isDynamicImportError && canReload) {
			window.location.reload();
		}
	}, [error]);

	return (
		<div className="relative overflow-hidden h-dvh flex flex-col justify-end lg:justify-center ">
			<BackgroundImage
				src="/offline/appUnavailableBackground.jpg"
				description="Tło"
				textOnImage=""
				className="bg-no-repeat bg-cover absolute inset-0 bg-right-top"
			/>
			<Image
				src={Pudzian404}
				description="Pudzian"
				textOnImage=""
				className="object-cover w-full absolute h-full right-0 [object-position:80%_10%] lg:object-contain"
				loading="lazy"
			/>
			<div className="flex  relative flex-col items-center lg:px-12 lg:items-center lg:w-[776px] mb-[106px] lg:mb-0">
				<Image
					src={Text404}
					description=""
					textOnImage="Przerwa techniczna"
					className="object-contain h-[115px] lg:h-[237px]"
					loading="lazy"
				/>
				<div className="font-bold uppercase italic -right-16 top-1 relative text-white lg:self-end lg:text-[1.875rem] lg:right-6 lg:top-1">
					{t('appUnavailableInfo')}
				</div>
				<DSButton className="my-4 lg:mb-0 lg:mt-8 w-[250px]" size="medium" color="primary" onClick={() => window.location.reload()}>
					{t('reload')}
				</DSButton>
			</div>
		</div>
	);
};

export default AppUnavailable;
